import { ToitEnPenteRainCoverTypes, ToitEnPenteStructureTypes } from "@iko-design-center/shared";
import React from "react";
import { Spacer } from "../../common/Spacer";
import { H1 } from "../../common/Typography";
import { useToitRainCover } from "./toitRainCover.hooks";
import { RadioButton } from "../../common/RadioButton";
import { Sidebar } from "../Sidebar";
import { getToitEnPenteRainCoverTranslations } from "./translations";
import { Intro, RadioButtonList } from "../../viewer/DesignCenter";
import { isMobile } from "../../../services/helpers.service";
import { useTabs } from "../../navigation/tabs.hook";
import { InfoList } from "../../common/InfoList";

export const ToitRainCover = () => {
  const {
    t,
    toitStructureType,
    toitRainCoverType,
    setToitRainCoverType,
    nextButtonDisabled,
    handleNextButtonClick,
  } = useToitRainCover();

  const { currentStep, tabs } = useTabs();
  const totalSteps = tabs.length

  return (
    <Sidebar
      handleNextButtonClick={handleNextButtonClick}
      nextButtonText={`${t("toitEnPente.toitRainCover.nextButton")} (${currentStep + 1}/${totalSteps})`}
      nextButtonDisabled={nextButtonDisabled}
    ><Intro>
        <H1 lineHeightPx={33}>{t("toitEnPente.toitRainCover.title")}</H1>
        {!isMobile() && <Spacer heightPx={32} />}
      </Intro>

      <RadioButtonList>
        <RadioButton
          value={ToitEnPenteRainCoverTypes.RAIN_COVER_PRESENT}
          checked={toitRainCoverType === ToitEnPenteRainCoverTypes.RAIN_COVER_PRESENT}
          onClick={() => setToitRainCoverType(ToitEnPenteRainCoverTypes.RAIN_COVER_PRESENT)}
          text={getToitEnPenteRainCoverTranslations(t, ToitEnPenteRainCoverTypes.RAIN_COVER_PRESENT)}
          disabled={false}
        />

        {!isMobile() && <Spacer heightPx={10} />}

        <RadioButton
          value={ToitEnPenteRainCoverTypes.RAIN_COVER_ABSENT}
          checked={toitRainCoverType === ToitEnPenteRainCoverTypes.RAIN_COVER_ABSENT}
          onClick={() => setToitRainCoverType(ToitEnPenteRainCoverTypes.RAIN_COVER_ABSENT)}
          text={getToitEnPenteRainCoverTranslations(t, ToitEnPenteRainCoverTypes.RAIN_COVER_ABSENT)}
          disabled={false}
        />
      </RadioButtonList>

      <Spacer heightPx={!isMobile() ? 62 : 16} />

      {toitStructureType === ToitEnPenteStructureTypes.ON_WOOD_RAFTERS &&
        toitRainCoverType === ToitEnPenteRainCoverTypes.RAIN_COVER_PRESENT && (
          <InfoList
            info={[t("toitEnPente.toitRainCover.raftersRaincoverPresentInfo0"), t("toitEnPente.toitRainCover.raftersRaincoverPresentInfo1")]}
            title={getToitEnPenteRainCoverTranslations(t, ToitEnPenteRainCoverTypes.RAIN_COVER_PRESENT)}
          />
        )}
      {toitStructureType === ToitEnPenteStructureTypes.ON_WOOD_RAFTERS &&
        toitRainCoverType === ToitEnPenteRainCoverTypes.RAIN_COVER_ABSENT && (
          <InfoList
            info={[t("toitEnPente.toitRainCover.raftersRaincoverAbsentInfo0"), t("toitEnPente.toitRainCover.raftersRaincoverAbsentInfo1"), t("toitEnPente.toitRainCover.raftersRaincoverAbsentInfo2")]}
            title={getToitEnPenteRainCoverTranslations(t, ToitEnPenteRainCoverTypes.RAIN_COVER_ABSENT)}
          />
        )}
      {toitStructureType === ToitEnPenteStructureTypes.ON_WOOD_BOARDS &&
        toitRainCoverType === ToitEnPenteRainCoverTypes.RAIN_COVER_PRESENT && (
          <InfoList
            info={[t("toitEnPente.toitRainCover.boardsRaincoverPresentInfo0"), t("toitEnPente.toitRainCover.boardsRaincoverPresentInfo1")]}
            title={getToitEnPenteRainCoverTranslations(t, ToitEnPenteRainCoverTypes.RAIN_COVER_PRESENT)}
          />
        )}
      {toitStructureType === ToitEnPenteStructureTypes.ON_WOOD_BOARDS &&
        toitRainCoverType === ToitEnPenteRainCoverTypes.RAIN_COVER_ABSENT && (
          <InfoList
            info={[t("toitEnPente.toitRainCover.boardsRaincoverAbsentInfo0"), t("toitEnPente.toitRainCover.boardsRaincoverAbsentInfo1"), t("toitEnPente.toitRainCover.boardsRaincoverAbsentInfo2")]}
            title={getToitEnPenteRainCoverTranslations(t, ToitEnPenteRainCoverTypes.RAIN_COVER_ABSENT)}
          />
        )}
    </Sidebar>
  );
};
